<template>
    <div style="background-color: #f2f2f2">
        <MyFeedHeader title="마이피드"></MyFeedHeader>
        <InfinityScroll :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage" :refresh-action="refresh" style="overflow:auto; flex:1;">
            <div style="padding:30px 15px;">
                <MyFeedLabel icon="my_lesson.png" label="구매내역" :isArrowHidden="true" :count="saleCount"></MyFeedLabel>
            </div>
            <div v-for="each, i in memberships" class="membership_wrap" :key="i">
                <div style="display:flex; flex-direction: column;">
                    <div style="background-color: #ff7703;border-top-left-radius: 10px; border-top-right-radius: 10px; color:white; padding:5px; ">
                        <div style="margin-top:25px; padding-left:8px; font-size:16px; font-weight: normal;">{{each.membership_name}}</div>
                        <div style="font-size:12px; margin-top:5px; text-align:right;">{{$Util.getMMSlashDDDayStr(each.sale_date)}} 구매완료</div>
                    </div>
                    <div style="position:relative; padding:10px 40px;background-color: white; border-bottom-right-radius: 10px; border-bottom-left-radius:10px; ">
                        <div style="font-size:17px; font-weight: bold; color:#464646; margin-top:5px;">{{$GlobalStore.loginInfo().name}}</div>
                        <div class="membership_info" style="margin-top:10px;">
                            <div class="membership_label">회원권</div><div class="membership_conts">{{each.membership_name}}</div>
                        </div>
                        <div class="membership_info">
                            <div class="membership_label">축구교실/코치</div><div class="membership_conts">{{each.branch_name}}</div>
                        </div>
                        <div class="membership_info">
                            <div class="membership_label">기간</div><div class="membership_conts">{{each.period_name}}</div>
                        </div>
                        <div class="membership_info">
                            <div class="membership_label">금액</div><div class="membership_conts">{{each.total_price | comma}}원</div>
                        </div>
                        <div style="left:-20px;" class="round"></div>
                        <div style="right:-20px;" class="round"></div>
                    </div>
                    <div style=" text-align:center; margin-top:15px;">
                        <div class="btns" style="background-color: #ff7703; color:white;" v-if="each.expire === '0'" @click="showReservation(each)">예약하기</div>
                        <!--<div class="btns" style="background-color: white" @click="showBranchDetail(each.branch_idx)">지점보기</div>-->
                        <!--<div class="btns" style="background-color: #da3c3c; color:white;" @click="showCancelConfirm">환불하기</div>-->
                    </div>
                </div>
            </div>
            <div style="height:10px;"></div>
        </InfinityScroll>
        <div v-if="isShowCancelConfirm">
            <div style="position:fixed; top :0px; left:0px; width:100%; height:100%; display:grid; place-items: center; background-color: rgba(0,0,0, 0.2)" @click.stop="() => {isShowCancelConfirm = false}">
                <div style="width:300px; background-color: white; border-radius: 15px; padding:30px 0px 15px 0px;text-align:center;">
                    <div style="font-weight:bold; color:#ff7703;">레슨권 환불</div>
                    <div style="margin-top:20px; font-size:14px; font-weight:bold;line-height:16px;">이용하신 회차를 제외한, 잔여 회차에 대한<br>금액의 부분만 환불이 이루어집니다.<br>이어서 환불을 진행하시겠습니까?</div>
                    <div style="font-weight:bold; font-size:15px; color:#ff7703; margin-top:30px;" @click.stop="refund">환불요청</div>
                    <div style="font-weight:bold; font-size:15px; margin-top:20px;" @click.stop="() => {isShowCancelConfirm = false}">취소</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MyFeedHeader from "../../common/MyFeedHeader";
    import InfinityScroll from "../../common/InfinityScroll";
    import MyFeedLabel from "../../common/MyFeedLabel";
    export default {
        name: "MyMemberships",
        components: {MyFeedLabel, InfinityScroll, MyFeedHeader},
        props : {
            saleCount : {
                type : Number,
                default : 0
            }
        },
        data(){
            return {
                isEnableNextPageHandle : false,
                memberships : [],
                isShowCancelConfirm : false,
            }
        },
        methods : {
            async getMyMemberships(){
                const res = await this.$Axios.get('/api/mymembership');
                this.memberships = res.data.memberships;
            },
            handleNextPage(){

            },
            showBranchDetail(branchIdx){
                  this.$GlobalStore.addModal('BranchDetail', {idx : branchIdx});
            },
            async showReservation(membership){
                const parameters = {};
                parameters.branchIdx = membership.branch_idx;
                const res = await this.$Axios.get('/api/mymembership/branch', {params : parameters});
                this.$GlobalStore.addModal('Reservation', {memberships : [membership], branch : res.data.branch});
            },
            showCancelConfirm(){
                this.isShowCancelConfirm = true;
            },
            refund(){
                this.isShowCancelConfirm = false;
                this.$GlobalStore.addModal('RefundComplete', {transitionName : ''});
            },
            refresh(){
                this.getMyMemberships();
            }
        },
        created(){
            this.getMyMemberships();
        }
    }
</script>

<style scoped>
.membership_wrap{padding:0px 20px; }
    .membership_wrap + .membership_wrap{
        margin-top:20px;
    }
    .membership_info{display:flex;}
    .membership_info + .membership_info{margin-top:8px;}
    .membership_label{font-size:13px; width:100px; color:#bbbbbb;}
    .membership_conts{font-size:13px; color:#464646; font-weight:bold;}
    .btns{display:inline-block; height:40px; font-size:15px; line-height:40px; border-radius:20px; width:140px;}
    .btns + .btns{margin-left:15px;}
    .round{position:absolute; top: 10px; width:40px; height:40px; border-radius:50%; background-color: #f2f2f2;}
</style>